import React from "react"
import SEO from "../components/seo"
import "normalize.css"
import { Button } from "../components/layout/Button"
import { CollectionsPreview } from "../components/CollectionsPreview"
import { StaticImage } from "gatsby-plugin-image"
import { graphql } from "gatsby"

const home = ({ data }) => {
  return (
    <div className="space-y-12">
      <SEO title="Fine Jewelry" description={data.shopifyShop} />

      <div className="overflow-hidden max-h-96">
        <StaticImage
          src="https://cdn.shopify.com/s/files/1/0561/1464/3101/files/3R0A6511.jpg?v=1631059345"
          className="object-fill max-w-full"
          alt="hero image"
        />
      </div>
      <Button href={"/objects"}>SHOP ALL OBJECTS</Button>
      <CollectionsPreview
        products={data.featuredProducts.edges[0].node.products}
        looks={data.looks.edges}
      />

      <div>
        <StaticImage
          src="https://cdn.shopify.com/s/files/1/0561/1464/3101/files/JASO862-172-1.jpg?v=1631059345"
          alt="image"
          className="object-cover overflow-hidden max-h-96"
          style={{
            height: "430px",
            width: "100%",
          }}
        />
        <p className="mt-4">
          UNIFORM OBJECT IS A COLLECTION OF FINE JEWELRY AND WARES WITH AN
          EMPHASIS ON PROCESS AND STIMULATION. IT IS A STUDY IN MATERIALS
          BROUGHT TO REALITY BY DAVID FARRUGIA.
        </p>
      </div>

      <Button href="/about">ABOUT US</Button>
    </div>
  )
}

export default home

export const query = graphql`
  {
    shopifyShop {
      description
      name
    }
    featuredProducts: allShopifyCollection(
      filter: { handle: { eq: "frontpage" } }
    ) {
      edges {
        node {
          products {
            title
            availableForSale
            descriptionHtml
            images {
              originalSrc
            }
            priceRange {
              minVariantPrice {
                amount
              }
              maxVariantPrice {
                amount
              }
            }
            handle
          }
        }
      }
    }

    looks: allShopifyCollection(
      filter: { handle: { regex: "/^look/" } }
      sort: { order: DESC, fields: updatedAt }
      limit: 3
    ) {
      edges {
        node {
          handle
          updatedAt
          image {
            src
          }
        }
      }
    }
  }
`
